<template src="./html/Edit.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import Multiselect from 'vue-multiselect'
	import Places from './../../places/layout/Places.vue'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'multiselect': Multiselect,
			'places': Places,

		},
		data () {
			return {
				data: null,
				resource: null,

				dropzone: {
					accepted: this.$env.ACCEPTED_DROPZONE_DOCS,
					url: process.env.ROOT + '/api/' + this.$lang.getLang(),
				},

				customers: [],
				users: null,
				teams: null,

				multiselect: {
					loading: false,
				}
			}
		},
		created () {
			this.init()
		},
		methods: {
			init() {
				this.getData()
				if(!this.user.hasRole('external_manager')) {
					this.getUsers()
					this.getTeams()
				}
			},
			getTeams() {
				this.$http.get('admin/projects/teams')
					.then(response => {
						this.teams = response.body
					})
			},
			getUsers() {
				var data = {
					roles: [
						'admin', 'manager', 'external_manager'
					]
				}
				this.$http.post('admin/roles/users', data)
				.then(response => {
					this.users = response.body
				}).catch(function(response) {
					console.log(response)
				})
			},
			getData() {
				var id = this.$route.params.id
				if(id) {
					this.$http.get('admin/projects/projects/' + id + '/edit')
					.then(response => {
						this.data = response.body

						this.resource = 'admin/projects/projects/' + this.data.id

						this.dropzone.url = process.env.ROOT + '/api/' + this.$lang.getLang() + '/admin/projects/projects/' + this.data.id
					}).catch(function(response) {
						console.log(response)
						swal({
							title: response.statusText,
							text: response.body,
							type: "warning"
						});
					})
				}
			},
			getCustomers(text) {
				this.multiselect.loading = true
				this.customers = []
				this.$http.get('admin/customers?per_page=50&sort=id|desc&text=' + text)
				.then(response => {
					this.customers = response.body.data
					this.multiselect.loading = false
				}).catch(response => {
					console.log(response)
					this.multiselect.loading = false
				})
			},
			reloadData() {
				this.getData()
			},
			update() {
				var loading = Ladda.create(this.$refs.btnUpdate)
				loading.start()
				this.$http.put('admin/projects/projects/' + this.$route.params.id, this.data)
				.then(response => {
					this.reload()
					loading.stop()
					swal(response.body.title, response.body.text, response.body.type)
				}).catch(function(response) {
					console.log(response)
					loading.stop()
				})
			},
			reload() {
				this.$emit('reload')
				this.getData()
			},
		}
	}	
</script>


// WEBPACK FOOTER //
// src/components/projects/projects/views/Edit.vue